import { render, staticRenderFns } from "./form-fields-edit-list.vue?vue&type=template&id=5c18c0ae&"
import script from "./form-fields-edit-list.vue?vue&type=script&lang=js&"
export * from "./form-fields-edit-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-fields-edit-list.vue"
export default component.exports